import template from '../../templates/EditorPageFooter.rt';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from '../../actions';

const mapStateToProps = function (state) {
  return {
    updateItemCount: actions.getItemUpdateCount(state.editor)
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onSave: () => dispatch(actions.savePendingUpdates()),
    onCancel: () => dispatch(actions.cancelPendingUpdates()),
    showCancelMessage: (title, message, buttons) => dispatch(actions.messageBoxEx_Show(true, 'system', title, message, buttons)),
    hideCancelMessage: () => dispatch(actions.messageBox_Show(false))
  }
};

class footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCancelMessage: false
    }
  }

  getCancelButtons = () => {
    return [{
      text: 'Yes',
      subtext: 'I want to cancel and lose all unsaved changes',
      onClick: () => {
        this.props.onCancel(this.props.state);
        this.props.hideCancelMessage();
      }
    },
      {
        text: 'No',
        subtext: 'I want to keep my unsaved changes',
        onClick: () => {
          this.props.hideCancelMessage();
        }
      }];
  }

  showCancelMessage = () => {
    this.props.showCancelMessage("Are you sure?", "WARNING! Canceling will clear all unsaved changes. Are you sure you want to do this?", this.getCancelButtons());
  }

  render() {
    return template.apply(this);
  }
}

footer.propTypes = {
  updateItemCount: PropTypes.number.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const Footer = connector(footer);

export default Footer;
